"use strict";

var _jquery = require("jquery");
var _jquery2 = _interopRequireDefault(_jquery);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
(0, _jquery2.default)(function () {
  (0, _jquery2.default)('.template-section-sku-slider-1 .slider-product').each(function (index, element) {
    var tagArrowLeft = (0, _jquery2.default)(element).data('tag-arrow-left');
    var tagArrowRight = (0, _jquery2.default)(element).data('tag-arrow-right');
    (0, _jquery2.default)(element).on('init', function (event, slick, direction) {
      (0, _jquery2.default)('.slick-slide a', (0, _jquery2.default)(element)).each(function (index2, element2) {
        var id = (0, _jquery2.default)(element2).data('id');
        (0, _jquery2.default)(element2).attr('id', id);
      });
    });
    (0, _jquery2.default)(element).slick({
      dots: true,
      arrows: true,
      mobileFirst: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: false,
      appendDots: (0, _jquery2.default)('.container-dots', (0, _jquery2.default)(element).closest('.row')),
      prevArrow: (0, _jquery2.default)('.button-arrow-prev', (0, _jquery2.default)(element).closest('.row')),
      nextArrow: (0, _jquery2.default)('.button-arrow-next', (0, _jquery2.default)(element).closest('.row'))
    });
  });
});